// ✅ SelectionBox.vue
<template>
  <div
    v-if="box.visible"
    class="selection-box"
    :style="{
      left: box.left + 'px',
      top: box.top + 'px',
      width: box.width + 'px',
      height: box.height + 'px'
    }"
  />
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';

const props = defineProps({
  icons: Array
});
const emit = defineEmits(['selection-change']);

const box = ref({
  visible: false,
  startX: 0,
  startY: 0,
  left: 0,
  top: 0,
  width: 0,
  height: 0,
});

function onMouseDown(e) {
  // Clicked on an empty area of the desktop
  if (e.button !== 0 || e.target.closest('.desktop-icon')) return;

  // Get the immediate element under the cursor
  const elementUnderMouse = document.elementFromPoint(e.clientX, e.clientY);
  if (!elementUnderMouse || !elementUnderMouse.classList.contains('desktop')) {
    return;
  }

  console.log('Clicked empty area of the desktop');

  box.value.visible = true;
  box.value.startX = e.clientX;
  box.value.startY = e.clientY;
  box.value.left = e.clientX;
  box.value.top = e.clientY;
  box.value.width = 0;
  box.value.height = 0;

  window.addEventListener('mousemove', onMouseMove);
  window.addEventListener('mouseup', onMouseUp);
}

function onMouseMove(e) {
  const x1 = box.value.startX;
  const y1 = box.value.startY;
  const x2 = e.clientX;
  const y2 = e.clientY;

  box.value.left = Math.min(x1, x2);
  box.value.top = Math.min(y1, y2);
  box.value.width = Math.abs(x1 - x2);
  box.value.height = Math.abs(y1 - y2);

  selectIconsInBox();
}

function onMouseUp() {
  selectIconsInBox();
  box.value.visible = false;
  window.removeEventListener('mousemove', onMouseMove);
  window.removeEventListener('mouseup', onMouseUp);
}

function selectIconsInBox() {
  const b = box.value;
  const selectedIds = [];

  props.icons.forEach((icon) => {
    const iconBox = {
      left: icon.x,
      top: icon.y,
      right: icon.x + 64,
      bottom: icon.y + 64,
    };

    const intersect = !(
      iconBox.left > b.left + b.width ||
      iconBox.right < b.left ||
      iconBox.top > b.top + b.height ||
      iconBox.bottom < b.top
    );

    if (intersect) selectedIds.push(icon.id);
  });

  emit('selection-change', selectedIds);
}

onMounted(() => {
  window.addEventListener('mousedown', onMouseDown);
});

onBeforeUnmount(() => {
  window.removeEventListener('mousedown', onMouseDown);
});
</script>

<style scoped>
.selection-box {
  position: absolute;
  pointer-events: none;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23000' stroke-width='1' stroke-dasharray='1.5' stroke-linecap='square'/%3e%3c/svg%3e");
}
</style>